export default __webpack_public_path__ + "static/Corprate_WhoWeAre_InternationalFranchises_02-ce246fc0ce5d154a3943a1cdd5955b75.jpg";